import { StripeInvoicePreview } from '../../../../../shared/graphql/graphql';
import { formatDate } from '../../../../../shared/helpers/functions/date';

export const getSubscriptionPreviewPeriod = (
  preview: StripeInvoicePreview | undefined | null,
) => ({
  start: formatDate(preview?.lines?.[0]?.periodStart),
  end: formatDate(preview?.lines?.[0]?.periodEnd),
});
